import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import './Filters.css';

import IconPreferences from '../svg/IconPreferences';
import ButtonIconV2 from '../common/ButtonIconV2';

function ButtonFilters({ active, onClick, onClear, showClear, className, style }) {
  return (
    <div className={`flexRow`} style={style}>
      { showClear ? (
        <div onClick={onClear} className={`small-button button-filter-clear ${className}`}>
          <span className={`type-small brand-primary`}>Clear</span>
        </div>
      ) : null}
      <ButtonIconV2
        className={`button-filter ${active ? `active` : ''} ${className}`}
        icon={<IconPreferences size={18} color={ active ? Config.BRAND_PRIMARY : Config.TYPE_SECONDARY } />}
        label={!active ? `Filters` : 'Close'}
        onClick={onClick}
      />
    </div>
  );
}

ButtonFilters.propTypes = {
  active : PropTypes.bool,
  onClick: PropTypes.func,
  onClear: PropTypes.func.isRequired,
  showClear: PropTypes.bool.isRequired,
  style: PropTypes.object,
  className: PropTypes.string
}

export default ButtonFilters;
